import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};
//
export const createTestimonial = async (formData) => {
  const response = await axiosInstance.post("testimonial", formData, {
    headers,
  });
  return response.data;
};
export const updateTestimonial = async (formData) => {
  const response = await axiosInstance.put("testimonial", formData, {
    headers,
  });
  return response.data;
};

export const fetchTestimonials = async () => {
  const response = await axiosInstance.get("testimonial", { headers });
  return response.data;
};

export const fetchTestimonialById = async (id) => {
  const response = await axiosInstance.get(`testimonial/${id}`, {
    headers,
  });
  return response.data;
};

export const publishTestimonial = async (id) => {
  return await await axiosInstance.patch(`testimonial/${id}/publish`, {
    headers,
  });
};

export const unPublishTestimonial = async (id) => {
  return await await axiosInstance.patch(`testimonial/${id}/unpublish`, {
    headers,
  });
};

export const markTestimonialFeatured = async (id) => {
  return await await axiosInstance.patch(`testimonial/${id}/featured`, {
    headers,
  });
};

export const markTestimonialUnFeatured = async (id) => {
  return await await axiosInstance.patch(`testimonial/${id}/unfeatured`, {
    headers,
  });
};

export const deleteTestimonial = async (id) => {
  return await axiosInstance.delete(`testimonial/${id}`, { headers });
};
